import React from "react";

function UserAvatar({ src, alt }) {
  return (
    <img
      id="userAvatar"
      src={src ? src : "/assets/pictures/avatar-light.svg"}
      alt={alt}
    />
  );
}

export default UserAvatar;
